export var ParecerEnum;
(function (ParecerEnum) {
    ParecerEnum["AGUARDANDO_ANALISE"] = "AGUARDANDO_ANALISE";
    ParecerEnum["APROVADO"] = "APROVADO";
    ParecerEnum["REPROVADO"] = "REPROVADO";
})(ParecerEnum || (ParecerEnum = {}));
(function (ParecerEnum) {
    ParecerEnum.mapDescricao = new Map([
        [ParecerEnum.AGUARDANDO_ANALISE, 'Aguardando Análise'],
        [ParecerEnum.APROVADO, 'Aprovado'],
        [ParecerEnum.REPROVADO, 'Reprovado'],
    ]);
    function getDescricao(key) {
        return ParecerEnum.mapDescricao.get(key);
    }
    ParecerEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        ParecerEnum.mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    ParecerEnum.getOptions = getOptions;
})(ParecerEnum || (ParecerEnum = {}));
